import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { HeaderWrapper } from './components/header'
import { ScrollTop } from './components/scroll-top/index'
import { Sidebar } from './components/sidebar/index'
import { DrawerMessenger } from '../partials'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
import { BotIcon } from 'lucide-react'
import { FooterWrapper } from './components/footer/index'
import useFcmToken from '../../Utils/useFcmToken'
import { FeatureGuard } from '../../Utils/featureComponents'
import { useFeature } from '../../Utils/featureFlagEngine'
import InitialOrg from '../../app/modules/accounts/components/organization/InitialOrg'
import { useAuthStore } from '../../store/authStore'
import IconBadge from '../../components/IconBadge'


const MasterLayout = () => {

  const location = useLocation()
  const isCanvasPage = location.pathname === '/workFlow-edit'
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  const { hasPermission } = useFeature()
  const user = useAuthStore((state) => state.userProfile?.requires_organization_setup)
  const isNotification = hasPermission("header_notifications")

  useFcmToken(isNotification)
  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='flex-column flex-column-fluid app-page' id='kt_app_page'>

          <HeaderWrapper />
          <div
            className={`position-relative flex-row-fluid flex-column app-wrapper${isCanvasPage ? '' : ' p-5 p-md-10 pb-0 pb-md-0'}`}
            id='kt_app_wrapper'
          >
            <Sidebar />
            <div
              className='flex-row-fluid flex-column mx-auto w-100 app-main'
              id='kt_app_main'
              style={isCanvasPage ? undefined : { maxWidth: 1320 }}
            >
              <div className='d-flex flex-column flex-column-fluid'>
                <Outlet />
              </div>
              <FooterWrapper />
            </div>
          </div>
          <FeatureGuard featureId='vulnerabilities_chat'>
            {/*
              The global entry point: no finding in scope, so it opens a chat
              with no subject rather than the "pick a vulnerability" gate.
            */}
            <div id='kt_drawer_chat_toggle' data-bs-toggle='modal'
              data-bs-target='#kt_modal_AI' className='ai_btn no_rotate' dir='ltr'
              onClick={() => useAuthStore.getState().SetAiEntryPoint('free')}>
              <IconBadge variant='primary' icon={BotIcon} size={30} />
            </div>
          </FeatureGuard>

          <DrawerMessenger />
          <ScrollTop />
        </div>
      </div>
      {user ? <InitialOrg /> : null}
      {/* <InitialOrg /> */}
    </PageDataProvider >
  )
}

export { MasterLayout }
